type AuthEvent = 'signed-out' | 'forbidden'
type Listener = () => void

const listeners: Record<AuthEvent, Set<Listener>> = {
  'signed-out': new Set(),
  forbidden: new Set(),
}

export const authEvents = {
  on(event: AuthEvent, fn: Listener) {
    listeners[event].add(fn)
    return () => listeners[event].delete(fn)
  },
  emit(event: AuthEvent) {
    listeners[event].forEach((fn) => fn())
  },
}
